import React from "react";
import { Box, Button } from "@mui/material";
import { isAndroid, isIOS, isMacOs, isWindows, osName } from "react-device-detect";
import {
  buildAppStoreUrl,
  buildEnrollmentAppUrl,
  buildPlayStoreUrl,
  buildPracticeTokenAppUrl,
  copyTextToClipboard,
} from "../../utils/helpers/enrollmentToken";

const CommonStoreButton = ({ enrollmentToken, token } = {}) => {
  const appUrl = enrollmentToken
    ? buildEnrollmentAppUrl(enrollmentToken)
    : token
      ? buildPracticeTokenAppUrl(token)
      : null;

  const appStoreHandler = async () => {
    if (isIOS || isMacOs) {
      const landingUrl = window.location.href;
      const storeUrl = buildAppStoreUrl();

      // 1) Copy first and wait until it finishes
      await copyTextToClipboard(landingUrl);

      // 2) Only then open the App Store
      window.location.assign(storeUrl);
      return;
    }

    if (isAndroid) {
      if (appUrl) {
        window.location.href = appUrl;
      } else {
        window.open(buildPlayStoreUrl({ enrollmentToken, token }));
      }
      return;
    }

    if (isWindows || osName === "Linux") {
      window.open(buildPlayStoreUrl({ enrollmentToken, token }));
    }
  };

  return (
    <Box padding="20px 0">
      <Button
        variant="contained"
        onClick={appStoreHandler}
        sx={{ textTransform: "capitalize" }}
      >
        Download BiosyncIQ Mobile app
      </Button>
    </Box>
  );
};

export default CommonStoreButton;
